// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

import { platformAdminPortalAccess } from "./platform-admin-portal-access";
import { platformAdminPortalSecurity } from "./platform-admin-portal-security";
import { platformAdminPortalUiSemantics } from "./platform-admin-portal-ui-semantics";

export const platformAdminPortalManagement = {
  ...platformAdminPortalUiSemantics,
  ...platformAdminPortalSecurity,
  ...platformAdminPortalAccess,
  summaryVisible: "显示中",
  summaryEntries: "入口数",
  deleteGroupTitle: "删除门户分组",
  deleteGroupConfirm: "确认删除分组“{name}”吗？仅在该分组下没有任何入口时可删除。",
  deleteGroupError: "该分组下还有 {count} 个入口，不能删除，请先调整入口分组。",
  deleteGroupSuccess: "门户分组已删除",
  title: "门户管理",
  subtitle: "统一维护门户外观、入口编排、接入设置与安全策略。",
  appearanceTitle: "门户外观",
  appearanceSubtitle: "维护门户 Logo、标题、副标题与展示文案。",
  appearanceNotice:
    "这一页当前维护门户 Logo、标题、副标题、登录页说明、首页欢迎语与页脚文案；分组标题请到门户分组页维护。",
  portalName: "门户名称",
  portalSubtitle: "门户副标题",
  loginTitle: "登录页标题",
  loginSubtitle: "登录页说明",
  homeWelcome: "首页欢迎语",
  footerText: "页脚文案",
  logoLabel: "Logo",
  logoTitle: "门户 Logo",
  logoDescription: "上传后会自动写入资产中心品牌空间，并同步更新门户展示。",
  uploadLogo: "上传 Logo",
  replaceLogo: "替换 Logo",
  clearLogo: "清除 Logo",
  logoCleared: "已清除 Logo",
  appearanceRestored: "已恢复默认",
  appearanceLogoUpdated: "Logo 已更新",
  entriesTitle: "门户入口展示",
  entriesSubtitle:
    "维护门户里的显示名称、描述、分组、排序、图标与显示状态；标准服务身份、域名和端口来自服务入口注册表。",
  groupsTitle: "门户分组",
  groupsSubtitle: "维护门户分组（像导航文件夹）及其显示顺序。",
  objects: {
    entry: "门户入口展示",
    group: "门户分组",
  },
  groupsCreate: "新建门户分组",
  groupsEditTitle: "编辑门户分组 · {name}",
  groupsEditTitleShort: "编辑门户分组",
  groupsSaveSuccess: "门户分组已更新",
  groupsCreateSuccess: "门户分组已创建",
  groupKey: "分组标识",
  groupName: "分组名称",
  groupLookup: "查找门户分组",
  groupPickerTitle: "查找门户分组",
  groupPickerApply: "带回门户分组",
  groupPickerEmpty: "暂无可选的门户分组",
  groupPickerRequired: "请先选择一个门户分组",
  groupDescription: "分组说明",
  groupStatus: "分组状态",
  groupSortOrder: "分组排序",
  entryName: "门户显示名称",
  entryDescription: "门户展示说明",
  entryGroup: "门户分组",
  entrySortOrder: "门户排序",
  entryDomain: "入口域名",
  entryAddress: "入口地址",
  entryActions: "门户入口操作",
  entryDetailTitle: "门户入口详情 · {name}",
  entryBasicTitle: "门户展示配置",
  entryEnabled: "门户启用",
  entryIconAppstore: "应用",
  entryIconFolder: "文件夹",
  entryIconRead: "文档",
  entryIconRocket: "火箭",
  entryIconUser: "用户",
  entryEditTitle: "编辑入口编排 · {name}",
  entryEditTitleShort: "编辑入口编排",
  entryUpdateSuccess: "入口编排已更新",
  groupPrimary: "常用区",
  groupTools: "工具区",
} as const;
